import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "9y3dt88m", 
    dataset: "production"
})